import * as React from "react";
const SvgHtmlLinkIcon = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M29.8161 9.63613V30.5872C29.816 31.6273 29.4028 32.6249 28.6673 33.3604C27.9318 34.0959 26.9342 34.5091 25.8941 34.5092H8.83859C7.79835 34.5092 6.80069 34.096 6.06508 33.3605C5.32946 32.625 4.91613 31.6274 4.91602 30.5872V5.92258C4.91602 4.88225 5.32929 3.88453 6.06491 3.1489C6.80054 2.41327 7.79826 2 8.83859 2H22.9637L29.8161 9.63613Z",
	fill: "#FFE4BE"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M13.5951 27.6697H32.7641C33.3794 27.6697 33.9696 27.9142 34.4047 28.3493C34.8398 28.7844 35.0843 29.3746 35.0843 29.9899V35.6798C35.0843 36.2952 34.8398 36.8853 34.4047 37.3204C33.9696 37.7556 33.3794 38 32.7641 38H13.5951C12.9797 38 12.3896 37.7556 11.9545 37.3204C11.5193 36.8853 11.2749 36.2952 11.2749 35.6798V29.9899C11.2749 29.3746 11.5194 28.7844 11.9545 28.3493C12.3896 27.9142 12.9797 27.6697 13.5951 27.6697Z",
	fill: "#FF9908"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M29.8163 9.63613H26.8859C25.8456 9.63602 24.8481 9.22269 24.1125 8.48707C23.377 7.75146 22.9638 6.7538 22.9639 5.71355V2L29.8163 9.63613Z",
	fill: "#FF9908"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M12.7788 35.3569C12.7788 35.2708 12.8044 35.1867 12.8522 35.1151C12.9 35.0436 12.968 34.9878 13.0475 34.9549C13.127 34.9219 13.2145 34.9133 13.2989 34.9301C13.3833 34.9469 13.4608 34.9884 13.5217 35.0492C13.5825 35.1101 13.624 35.1876 13.6408 35.272C13.6576 35.3564 13.6489 35.4439 13.616 35.5234C13.5831 35.603 13.5273 35.6709 13.4557 35.7187C13.3842 35.7665 13.3 35.7921 13.214 35.7921C13.1568 35.7922 13.1002 35.781 13.0473 35.7591C12.9945 35.7373 12.9465 35.7052 12.906 35.6648C12.8656 35.6244 12.8336 35.5764 12.8117 35.5235C12.7899 35.4707 12.7787 35.414 12.7788 35.3569Z",
	fill: "white"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M18.9951 30.197V35.7143H18.1791V33.3365H15.4282V35.7144H14.6123V30.197H15.4282V32.5672H18.1791V30.197L18.9951 30.197Z",
	fill: "white"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M23.02 30.9664H21.6912V35.7143H20.883V30.9664H19.5542V30.197H23.02V30.9664Z",
	fill: "white"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M29.4305 30.197V35.7143H28.6146V31.6658L26.7651 34.642H26.4154L24.5659 31.6658V35.7144H23.75V30.1971H24.5659L26.5864 33.4297L28.6146 30.1971L29.4305 30.197Z",
	fill: "white"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M33.4787 34.945V35.7143H30.417V30.197H31.2251V34.945L33.4787 34.945Z",
	fill: "white"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M14.7188 16.4352L11.4176 17.7653L14.7188 19.0834V20.0024L10.3052 18.2249V17.2938L14.7188 15.5284V16.4352Z",
	fill: "#FF9908"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M16.8126 21.1376H16.105L18.6145 14.4393H19.3221L16.8126 21.1376Z",
	fill: "#FF9908"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M24.9427 17.2938V18.2248L20.5171 20.0024V19.0834L23.8181 17.7653L20.5171 16.4352V15.5284L24.9427 17.2938Z",
	fill: "#FF9908"
}));
export default SvgHtmlLinkIcon;
